import { CherryPayApi } from "../api/models";

export type DisbursementAccTransactionFilterParams = {
  /** UTC ISO instant of the local start-of-day (see DateUtil.setStartEndDate). */
  startDate?: string;
  /** UTC ISO instant of the next local start-of-day, exclusive (see DateUtil.setStartEndDate). */
  endDate?: string;
  referenceTypes?: CherryPayApi.DisbursementReferenceType[];
  timeZone?: string;
};

export const disbursementReferenceTypeOptions: {
  value: CherryPayApi.DisbursementReferenceType;
  label: string;
}[] = [
  { value: "LoyaltyPointsTransfer", label: "Loyalty Points Transfer" },
  { value: "CardLoadFee", label: "Card Load Fee" },
  { value: "InitialCardLoad", label: "Initial Card Load" },
  { value: "Other", label: "Other" },
];

/**
 * Builds the query string for the Disbursement Account Transactions report and its CSV download.
 * Empty values are omitted and reference types are sent as repeated `referenceTypes` keys.
 */
export function buildDisbursementAccTransactionParams(
  params: DisbursementAccTransactionFilterParams
): URLSearchParams {
  const searchParams = new URLSearchParams();

  if (params.startDate) searchParams.append("startDate", params.startDate);
  if (params.endDate) searchParams.append("endDate", params.endDate);
  params.referenceTypes?.forEach((referenceType) =>
    searchParams.append("referenceTypes", referenceType)
  );
  if (params.timeZone) searchParams.append("timeZone", params.timeZone);

  return searchParams;
}
